export default function Philosophy() {
  return (
    <section
      data-testid="wynn-philosophy"
      className="relative border-t border-[#F4F1EC]/10 bg-[#0A0910] overflow-hidden"
    >
      <div
        aria-hidden
        className="absolute inset-0 opacity-50"
        style={{
          background:
            "radial-gradient(45% 50% at 20% 30%, rgba(255,170,210,0.18) 0%, rgba(7,6,8,0) 60%), radial-gradient(45% 50% at 85% 80%, rgba(168,230,255,0.16) 0%, rgba(7,6,8,0) 65%)",
        }}
      />
      <div className="relative max-w-[1000px] mx-auto px-6 md:px-10 py-28 md:py-36 text-center">
        <div className="text-[11px] uppercase tracking-[0.32em] text-[#F4F1EC]/55 font-body">
          The philosophy
        </div>
        <p className="mt-8 font-display tracking-tight leading-[1.15] text-[clamp(1.8rem,4.4vw,3.2rem)] font-light text-[#F4F1EC]">
          No launch noise. No countdown timers. No turning creativity into a{" "}
          <span className="italic text-aurora">productivity game</span>. WYNN
          opens, it greets you, it offers a doorway. You finish, you close the
          app, you return to the work. That&apos;s the whole loop.
        </p>
        <div className="mt-12 flex items-center justify-center gap-4">
          <span className="inline-block h-px w-12 bg-[#F4F1EC]/30" />
          <span className="text-[11px] uppercase tracking-[0.3em] text-[#F4F1EC]/55 font-body">
            Quiet, generous, a little sacred
          </span>
          <span className="inline-block h-px w-12 bg-[#F4F1EC]/30" />
        </div>
      </div>
    </section>
  );
}
